import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "card"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_PrimeVueColumn = _resolveComponent("PrimeVueColumn")!
  const _component_PrimeVueDataTable = _resolveComponent("PrimeVueDataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      class: "mb-3",
      title: "Domains"
    }),
    (_ctx.domainsLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_PrimeVueSkeleton, {
            class: "mb-2",
            height: "20px"
          }),
          _createVNode(_component_PrimeVueSkeleton, {
            class: "mb-2",
            height: "20px"
          }),
          _createVNode(_component_PrimeVueSkeleton, {
            class: "mb-2",
            height: "20px"
          })
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_PrimeVueDataTable, {
            value: _ctx.domains.data
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PrimeVueColumn, {
                header: "Domain",
                field: "domain",
                sortable: ""
              }),
              _createVNode(_component_PrimeVueColumn, {
                header: "Purpose",
                field: "purpose",
                sortable: ""
              }),
              _createVNode(_component_PrimeVueColumn, {
                header: "Project name",
                field: "project_name",
                sortable: ""
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]))
  ], 64))
}